export default __webpack_public_path__ + "static/media/product15.45c0fb5e.png";